export default "__VITE_ASSET__BpPAUwSx__"